import { emptyArray, emptyObject } from 'ui-components/default-props/empty';

import * as Actions from './orders.selected-orders.actions';
import * as OrderActions from '../orders.actions';

const initialState = {
  selectedOrderIds: emptyArray,
  allOrdersSelected: false,
  outdatedIds: emptyObject,
};

export const reduce = (state = initialState, action = {}) => {
  const { selectedOrderIds, type, outdatedIds = {} } = action;
  const newOutdatedIds = { ...state.outdatedIds, ...outdatedIds };
  switch (type) {
    case Actions.SET_SELECTED_ORDERS:
      return {
        ...state,
        allOrdersSelected: false,
        selectedOrderIds: selectedOrderIds.filter((id) => !state.outdatedIds[id]),
      };
    case Actions.SELECT_ALL_ORDERS:
      return {
        ...state,
        allOrdersSelected: true,
        selectedOrderIds: emptyArray,
      };
    case Actions.CLEAR_SELECTED_ORDERS:
      return {
        ...state,
        allOrdersSelected: false,
        selectedOrderIds: emptyArray,
        outdatedIds: emptyObject,
      };
    case Actions.ADD_OUTDATED_ORDERS:
      return {
        ...state,
        selectedOrderIds: state.selectedOrderIds.filter((id) => !newOutdatedIds[id]),
        outdatedIds: newOutdatedIds,
      };
    case OrderActions.SET_HOLD_UNTIL_DATE_REQUEST: {
      const { payload } = action;

      return {
        ...state,
        selectedOrderIds: state.selectedOrderIds.filter((selectedId) => !payload.fulfillmentPlanIds.includes(selectedId)),
      };
    }
    case OrderActions.GET_ORDERS_SUCCESS: {
      return {
        ...state,
        outdatedIds: emptyObject,
      };
    }
    default:
      return state;
  }
};

export { namespace } from './orders.selected-orders.reducer.metadata';
